export class MapWithTtl {
    delegate = new Map();
    getTtl;
    constructor(getTtl) {
        this.getTtl = getTtl;
    }
    set(key, value) {
        const existing = this.delegate.get(key);
        if (existing !== undefined) {
            clearTimeout(existing.timeout);
        }
        this.delegate.set(key, {
            value,
            timeout: this.createTimeout(key, value)
        });
    }
    get(key) {
        const wrapper = this.delegate.get(key);
        return wrapper?.value;
    }
    has(key) {
        return this.delegate.has(key);
    }
    delete(key) {
        const existing = this.delegate.get(key);
        if (existing !== undefined) {
            clearTimeout(existing.timeout);
            this.delegate.delete(key);
        }
    }
    clear() {
        this.delegate.forEach((value) => {
            clearTimeout(value.timeout);
        });
        this.delegate.clear();
    }
    size() {
        return this.delegate.size;
    }
    *values() {
        for (const v of this.delegate.values()) {
            yield v.value;
        }
    }
    forEach(cb) {
        this.delegate.forEach((valueWrapper, key) => {
            cb(valueWrapper.value, key);
        });
    }
    createTimeout(key, value) {
        return setTimeout(() => {
            this.delete(key);
        }, this.getTtl(value));
    }
}
//# sourceMappingURL=MapWithTtl.js.map